var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 136,
    viewBox: "0 0 69 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.059137 13.8419L-0.00153067 0.30332C37.3854 0.135786 67.8233 30.3021 67.9908 67.6831C68.1583 105.07 37.992 135.516 0.605119 135.683L0.544451 122.145C30.4543 122.011 54.5862 97.6556 54.4522 67.7457C54.3182 37.8458 29.9694 13.7079 0.059137 13.8419Z",
    fill: "#F6F7F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfCircle);
export default __webpack_public_path__ + "static/media/halfCircle.9e51a37ba43463dd36dcba801465c160.svg";
export { ForwardRef as ReactComponent };